var map = {
	"./progame_sucai_add.png": "3545",
	"./progame_sucai_clear.png": "0ca2",
	"./progame_sucai_delete.png": "5fb8",
	"./progame_sucai_down.png": "500f",
	"./progame_sucai_up.png": "2c19",
	"./program_back.png": "0b96",
	"./program_behind.png": "29fc",
	"./program_bottom.png": "510f",
	"./program_bottomalign.png": "4f78",
	"./program_centeralign.png": "c1e5",
	"./program_clear.png": "455d",
	"./program_delete.png": "101f",
	"./program_fullscreen.png": "d3ae",
	"./program_horscreen.png": "053f",
	"./program_leftalign.png": "3a02",
	"./program_middkealign.png": "b024",
	"./program_pre.png": "1743",
	"./program_rightalign.png": "45b5",
	"./program_text_A.png": "4069",
	"./program_text_AA.png": "dcea",
	"./program_text_Abg.png": "d0b1",
	"./program_text_B.png": "9d64",
	"./program_text_I.png": "d3dd",
	"./program_text_U.png": "0fc5",
	"./program_text_VA.png": "a636",
	"./program_text_bottom.png": "8f34",
	"./program_text_center.png": "32fa",
	"./program_text_left.png": "f0c4",
	"./program_text_middle.png": "0bdf",
	"./program_text_right.png": "d9fa",
	"./program_text_top.png": "f630",
	"./program_top.png": "a3db",
	"./program_topalign.png": "d6d9",
	"./program_verticalscreen.png": "6bba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "602b";